export type MaterialIconType = keyof typeof MaterialIcons;

export function isMaterialIcon(icon: string): icon is MaterialIconType {
  return Object.prototype.hasOwnProperty.call(MaterialIcons, icon);
}

export function getMaterialIcon(icon: string) {
  if (!isMaterialIcon(icon)) return undefined;
  return MaterialIcons[icon];
}

// Names of supported material-ui icons per https://fonts.google.com/icons?icon.set=Material+Icons&icon.style=Outlined
export const MaterialIcons = {
  // Remapped icons (key !== value)
  filter: 'filter_alt',
  more: 'more_vert',
  pin: 'push_pin',
  thumb: 'thumb_up',

  // Direct mappings (key === value)
  account_balance: 'account_balance',
  add: 'add',
  add_circle: 'add_circle',
  arrow_back: 'arrow_back',
  arrow_downward: 'arrow_downward',
  arrow_drop_down: 'arrow_drop_down',
  arrow_drop_up: 'arrow_drop_up',
  arrow_forward: 'arrow_forward',
  arrow_upward: 'arrow_upward',
  assignment: 'assignment',
  attach_file: 'attach_file',
  auto_awesome: 'auto_awesome',
  bar_chart: 'bar_chart',
  block: 'block',
  bookmark: 'bookmark',
  business: 'business',
  calculate: 'calculate',
  check: 'check',
  checklist: 'checklist',
  close: 'close',
  close_fullscreen: 'close_fullscreen',
  code: 'code',
  construction: 'construction',
  content_copy: 'content_copy',
  content_cut: 'content_cut',
  content_paste: 'content_paste',
  csv: 'csv',
  dark_mode: 'dark_mode',
  description: 'description',
  done: 'done',
  download: 'download',
  drag_handle: 'drag_handle',
  drag_indicator: 'drag_indicator',
  error: 'error',
  event: 'event',
  filter_center_focus: 'filter_center_focus',
  first_page: 'first_page',
  flag: 'flag',
  format_bold: 'format_bold',
  format_clear: 'format_clear',
  format_indent_decrease: 'format_indent_decrease',
  format_indent_increase: 'format_indent_increase',
  format_italic: 'format_italic',
  format_list_bulleted: 'format_list_bulleted',
  format_list_numbered: 'format_list_numbered',
  format_quote: 'format_quote',
  format_strikethrough: 'format_strikethrough',
  format_underlined: 'format_underlined',
  forum: 'forum',
  fullscreen: 'fullscreen',
  function: 'function',
  functions: 'functions',
  group: 'group',
  group_add: 'group_add',
  help: 'help',
  highlight: 'highlight',
  horizontal_rule: 'horizontal_rule',
  info: 'info',
  keyboard_arrow_down: 'keyboard_arrow_down',
  keyboard_arrow_left: 'keyboard_arrow_left',
  keyboard_arrow_right: 'keyboard_arrow_right',
  keyboard_arrow_up: 'keyboard_arrow_up',
  keyboard_double_arrow_down: 'keyboard_double_arrow_down',
  keyboard_double_arrow_left: 'keyboard_double_arrow_left',
  keyboard_double_arrow_right: 'keyboard_double_arrow_right',
  keyboard_double_arrow_up: 'keyboard_double_arrow_up',
  keyboard_tab: 'keyboard_tab',
  keyboard_tab_rtl: 'keyboard_tab_rtl',
  last_page: 'last_page',
  light_mode: 'light_mode',
  link: 'link',
  link_off: 'link_off',
  lock: 'lock',
  menu: 'menu',
  new_releases: 'new_releases',
  open_in_full: 'open_in_full',
  open_in_new: 'open_in_new',
  open_with: 'open_with',
  palette: 'palette',
  pivot_table_chart: 'pivot_table_chart',
  poll: 'poll',
  print: 'print',
  redo: 'redo',
  refresh: 'refresh',
  remove: 'remove',
  replay: 'replay',
  rss_feed: 'rss_feed',
  save: 'save',
  skip_next: 'skip_next',
  skip_previous: 'skip_previous',
  sort: 'sort',
  straighten: 'straighten',
  swap_horiz: 'swap_horiz',
  swap_vert: 'swap_vert',
  sync: 'sync',
  table_chart: 'table_chart',
  trending_down: 'trending_down',
  trending_flat: 'trending_flat',
  trending_up: 'trending_up',
  tune: 'tune',
  undo: 'undo',
  unfold_less: 'unfold_less',
  unfold_more: 'unfold_more',
  verified: 'verified',
  vertical_align_bottom: 'vertical_align_bottom',
  vertical_align_top: 'vertical_align_top',
  view_column: 'view_column',
  view_list: 'view_list',
  visibility: 'visibility',
  visibility_off: 'visibility_off',
  warning: 'warning',
  workspaces: 'workspaces',

  // add more as needed... I think that's all of them that are in the Bits file
  // and the rest will need to be added as a custom Josh Icon.
};
